import { jsx as _jsx } from "react/jsx-runtime";
import { ShortUrl } from "@air/api";
import { InlineInput } from "@air/component-inline-input";
import { Button } from "@air/primitive-button";
import { memo, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { validateAssetTitle } from "~/components/AssetModal/Header/components/EditableAssetModalHeaderTitle";
import { updateBoardCollectionClipsAction } from "~/store/boardCollection/actions";
import { boardCollectionFormSelector, boardCollectionSessionIdSelector, boardCollectionShortIdSelector } from "~/store/boardCollection/selectors";
export const BoardCollectionGalleryAssetTitle = /*#__PURE__*/ memo((param)=>{
    let { clip } = param;
    const dispatch = useDispatch();
    const sessionId = useSelector(boardCollectionSessionIdSelector);
    const form = useSelector(boardCollectionFormSelector);
    const shortId = useSelector(boardCollectionShortIdSelector);
    const [isEditing, setIsEditing] = useState(false);
    const defaultValue = clip.title;
    const [value, setValue] = useState(defaultValue);
    useEffect(()=>{
        setValue(defaultValue);
    }, [
        defaultValue
    ]);
    const onSubmit = useCallback((newTitle)=>{
        if (!sessionId) {
            return;
        }
        dispatch(updateBoardCollectionClipsAction({
            clips: [
                {
                    ...clip,
                    title: newTitle !== null && newTitle !== void 0 ? newTitle : ""
                }
            ]
        }));
        ShortUrl.batchUpdateFormAssets(shortId, form.id, {
            formSessionId: sessionId,
            update: {
                title: !newTitle ? null : newTitle
            },
            assetIds: [
                clip.assetId
            ]
        });
    }, [
        clip,
        dispatch,
        form.id,
        sessionId,
        shortId
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "my-1",
        children: isEditing ? /*#__PURE__*/ _jsx(InlineInput, {
            rows: 1,
            allowNewLines: false,
            label: "Asset name",
            onSubmit: (value)=>{
                setIsEditing(false);
                onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(value);
            },
            onCancel: ()=>{
                setValue(defaultValue);
                setIsEditing(false);
            },
            onChange: setValue,
            inputClassName: "-ml-px text-16 md:text-16 font-medium py-[5px] h-9",
            defaultValue: value,
            validate: validateAssetTitle
        }) : /*#__PURE__*/ _jsx(Button, {
            appearance: "ghost",
            color: "grey",
            className: "h-9 w-full justify-start px-2 text-16 font-medium",
            onClick: ()=>setIsEditing(true),
            children: /*#__PURE__*/ _jsx("span", {
                className: "truncate",
                children: value || defaultValue
            })
        })
    });
});
BoardCollectionGalleryAssetTitle.displayName = "BoardCollectionGalleryAssetTitle";
